//  @/store/modules/cpp.js
import Vue from 'vue'

const state = {
    headers: [
        {
            text: 'Appareil',
            value: 'Appareil'
        },
        {
            text: 'Noir - aggressif',
            value: 'K-1'
        },
        {
            text: 'Noir - compétitif',
            value: 'K-2'
        },
        {
            text: 'Noir - profitable',
            value: 'K-3'
        },
        {
            text: 'Couleurs - aggressif',
            value: 'CMY-1',
        },
        {
            text: 'Couleurs - compétitif',
            value: 'CMY-2',
        },
        {
            text: 'Couleurs - profitable',
            value: 'CMY-3',
        },
    ],
    ref: {
        tags: [
            {
                name: 'K',
                title: 'Noir',
                icon: 'mdi-printer',
                color: 'monochrome-gradient',
            },
            {
                name: 'CMY',
                title: 'Couleurs',
                icon: 'mdi-printer',
                color: 'color-gradient',
            },
            {
                name: 'SCN',
                title: 'Numérisations',
                icon: 'mdi-scanner',
                color: 'deep-purple darken-4',
            }
        ],
        levels: [
            'Agressif',
            'Concurrentiel',
            'Profitable',
        ],
        input: {
            step: 0.001,
            min: 0.004,
            max: 1

        },
        default: {
            K: [0,0,0],
            CMY: [0,0,0],
            SCN: [0.005,0.005,0.005],
        },
    },
    items: [],
  }
  
  const mutations = {
    SET_LISTENER (state, listener) {
      state.listener = listener
    },
    SET_ITEM (state, doc) {
      const data = doc.data()
      state.items = {
        ...state.items, 
        [doc.id]: data
      }
    },
    UPDATE_ITEM (state, doc) {
      state.items[doc.id] = doc.data()
    },
    DELETE_ITEM (state, doc) {
      Vue.delete(state.items, doc.id)
    },
  }

  const getters = {}
  
  const actions = {
    async init({ commit, state, rootState }) {
      commit('SET_LISTENER', 
      rootState.db.collection('cpp').onSnapshot(snapshot => {
        let changes = snapshot.docChanges()
        changes.forEach(change => {
          let type = change.type
          let doc = change.doc
          
          if(type === 'added') commit('SET_ITEM', doc)
          else if(type === 'modified') commit('UPDATE_ITEM', doc)
          else if(type === 'removed') commit('DELETE_ITEM', doc)
        })
      }, (error) => {console.log(error.message)}))
    },
    async add({ rootState }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      data.updates = [ update ]

      let response = await rootState.db.collection('cpp').add(data)
      return response
    },
    async set({ rootState }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      data[1].updates = [ ...data[1].updates, update ]

      let ref = rootState.db.collection('cpp').doc(data[0])
      let response = await ref.set(data[1])
      return response
    },
    async delete({ rootState }, id) {
      let response = await rootState.db.collection('cpp').doc(id).delete()
      return response
    },
    async close({ rootState }) { 
      let response = await rootState.db.collection('cpp').onSnapshot(() => {})
      return response
    },
  }
  
  export default { 
    namespaced: true, state, mutations, getters, actions
  }